// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".modal-video{position:relative;border-radius:var(--fvzeor);overflow:hidden;outline:none}.modal-video:before{content:\"\";display:block;padding-bottom:56.25%}.modal-video iframe{position:absolute;top:0;bottom:0;left:0;right:0;max-width:100%;max-height:100%}", ""]);
// Exports
module.exports = exports;
